import { Flex, Pagination } from '@applyboard/crystal-ui';
import { useIntakeManagementPageProps } from '~/data';
import { useFilterField } from '~/hooks';
import { useSearchResult } from '~/context';

export function IntakesPagination() {
  const pageNumberFilter = useFilterField('pageNumber', 'Pagination');
  const pageSizeFilter = useFilterField('pageSize', 'Pagination');
  const { totalIntakes } = useSearchResult();
  const { initialProps } = useIntakeManagementPageProps();

  return (
    <Flex align="center" pt={10} grow={1}>
      <Flex.Item grow={1}>
        <Pagination
          numItems={totalIntakes}
          currentPage={pageNumberFilter.value}
          pageSize={pageSizeFilter.value}
          onPageSizeChange={(pageSize) => pageSizeFilter.setValue(pageSize)}
          disabled={totalIntakes <= 0}
          onPageChange={(pageNumber) => pageNumberFilter.setValue(pageNumber)}
          variant="items"
          pageSizeOptions={initialProps?.referenceData?.pageSizes}
        />
      </Flex.Item>
    </Flex>
  );
}
